import {
  MealReplacementsConnectorApollo,
  ReplaceMealConnectorApollo,
  InsertFavoriteToDayplanConnectorApollo,
  useTimestamp,
  createDateObject,
} from '@front-activerse/common-components';

import { useParams } from 'react-router-dom';
import DayPlanMealReplacementContainer from './components/DayPlanMealReplacementContainer';

const DayPlanMealReplacementPage = () => {
  const { date } = useParams();
  const { timestamp2 } = useTimestamp();

  return (
    <MealReplacementsConnectorApollo date={date}>
      {({ loadDayPlanMealReplacements }) => (
        <ReplaceMealConnectorApollo date={createDateObject(date)}>
          {({ replaceMeal }) => (
            <InsertFavoriteToDayplanConnectorApollo date={createDateObject(date)}>
              {({ insertFavoriteToDayplan }) => (
                <DayPlanMealReplacementContainer
                  key={timestamp2}
                  timestamp={timestamp2}
                  loadDayPlanMealReplacements={loadDayPlanMealReplacements}
                  replaceMeal={replaceMeal}
                  insertFavoriteToDayplan={insertFavoriteToDayplan}
                />
              )}
            </InsertFavoriteToDayplanConnectorApollo>
          )}
        </ReplaceMealConnectorApollo>
      )}
    </MealReplacementsConnectorApollo>
  );
};

export default DayPlanMealReplacementPage;
